export default "__VITE_ASSET__7e2e21a2__"